module.exports = "<p>\n  settings works!\n</p>\n"